const isElectron = window && window.process && window.process.type;

export const saveToFile = async (content: string, filename: string): Promise<void> => {
  if (isElectron) {
    const fs = window.require('fs').promises;
    const path = window.require('path');
    const { dialog } = window.require('electron').remote;

    const { filePath } = await dialog.showSaveDialog({
      defaultPath: path.join(process.cwd(), filename),
    });

    if (filePath) {
      await fs.writeFile(filePath, content);
    }
  } else {
    // Web fallback: use browser's download capability
    const blob = new Blob([content], { type: 'text/plain' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
    URL.revokeObjectURL(url);
  }
};